<script lang="ts">
  import {createEventDispatcher} from 'svelte';

  export let isDialogOpen = false;
  export let autoDismissDialog = false;
  export let useIfShow = false;
  export let noBackground = false;
  export let noTouch = false;

  const dispatch = createEventDispatcher();

  let dialogElement: HTMLDivElement;

  function closeDialog(event: Event) {
    if (!autoDismissDialog) return;
    const target = event.target;
    if (target !== dialogElement) return;
    isDialogOpen = false;
    dispatch('close');
  }
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-no-static-element-interactions -->
{#if useIfShow}
  <div
    bind:this={dialogElement}
    on:click={closeDialog}
    class="{isDialogOpen ? '' : 'hidden'} {noTouch
      ? 'pointer-events-none'
      : ''} absolute left-0 top-0 h-full w-full {noBackground ? '' : 'bg-zinc-900/40'}"
    style="z-index:100;"
  >
    <slot></slot>
  </div>
{:else if isDialogOpen}
  <div
    bind:this={dialogElement}
    on:click={closeDialog}
    style="z-index:99;"
    class="absolute left-0 top-0 h-full w-full {noBackground ? '' : 'bg-zinc-900/40'}"
  >
    <slot></slot>
  </div>
{/if}
